// Single router instance. routeTree.gen.ts is written by
// @tanstack/router-plugin/vite from src/routes/ on every dev/build.

import { createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
